import { Stack, useTheme } from '@chakra-ui/react';

import { ProductItem as ProductItemType } from 'types';

import { ProductItem } from './component';

interface ProductListProps {
  list: ProductItemType[];
}

const ProductList = ({ list }: ProductListProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepSuccess: { productList }
        }
      }
    }
  } = useTheme();

  return (
    <Stack
      borderTop='4px solid'
      borderTopColor={productList.borderTopColor}
      bg={productList.background}
      overflow='hidden'
      gap={0}
      w='full'
    >
      {list.map((product) => (
        <Stack gap='5px' w='100%' key={product.id}>
          <ProductItem item={product} />
        </Stack>
      ))}
    </Stack>
  );
};

export default ProductList;
